/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Category_NoteInputs */



/**
* | output |
* | --- |
* | "This period closed before itemised charges were recorded, so only its totals are shown." |
*
* @param {Receipt_Category_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_category_note = /** @type {((inputs?: Receipt_Category_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Category_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Zeitraum wurde abgeschlossen, bevor Einzelposten erfasst wurden – daher werden nur die Summen angezeigt.")
	return /** @type {LocalizedString} */ ("This period closed before itemised charges were recorded, so only its totals are shown.")
});